export class CasingGradeConstants {
  static CASING_GRADE_VALUES: string[] = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'System Grade',
    'Make'
  ];

  // Field length mappings for numeric input fields (control names)
  private static FIELD_LENGTH_MAP: { [key: string]: number } = {
    casingGradeTier: 1,
    casingGradeNtr: 2,
    casingGradeAge: 3,
    casingGradeCasingSize: 1,
    casingGradeNail: 2,
    casingGradeRnailCrown: 2,
    casingGradeRnailShoulder: 2,
    casingGradeSr: 2,
    casingGradeMaxRepairs: 2,
    // data-field attribute fallbacks from template
    makeTier: 1,
    ntr: 2,
    ageMonths: 3,
    sizeTier: 1,
    nail: 2,
    rnailCrown: 2,
    rnailShoulder: 2,
    sr: 2,
    max: 2
  };

  /**
   * Enforces numeric input with field-specific max length.
   * Identifies the field by checking formControlName, data-control-name or data-field.
   * Removes non-digit characters and truncates to the configured max digit length.
   * Example: sizeTier (1) typing 123 -> 1; ntr (2) typing 456 -> 45.
   */
  static enforceThreeDigits(event: any): void {
    const input = event.target as HTMLInputElement;
    const fieldName =
      input.getAttribute('formControlName') || input.getAttribute('data-control-name') || input.getAttribute('data-field') || '';
    const maxLength = this.FIELD_LENGTH_MAP[fieldName] || 3;

    // Keep only digits
    let digits = input.value.replace(/[^0-9]/g, '');

    // Truncate to allowed length (prioritize first entered digits for consistency with earlier behavior)
    digits = digits.slice(0, maxLength);

    // Prevent leading minus or other artifacts; allow empty
    input.value = digits;
    // Angular [formControl] handles updating the model.
  }
}
